import { render, staticRenderFns } from "./pickup-request.vue?vue&type=template&id=705ce603"
import script from "./pickup-request.vue?vue&type=script&lang=js"
export * from "./pickup-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports